const axios = require('axios');
const { configEnv } = require('../config/config.js')

const genericRequestTemplate = (endpoint, body, method, token, params, contentType = 'application/json') => {
  let paramsString = null
  let tokenHeader
  let data
  if(body) data = JSON.stringify(body);
  if(params) paramsString = "?" + Object.keys(params).map(key => key + '=' + params[key]).join('&');
  if(token) {
    tokenHeader = {
      'Authorization': `Bearer ${token}`
    }
  }
  const config = {
    method: method,
    url: `${configEnv.serverlessUrl}/${endpoint}${paramsString ? paramsString : ''}`,
    headers: {
      ...tokenHeader,
      'Content-Type': contentType
    },
    data: data
  };
  return axios(config)
}

const verifyValidContractId = (params, token) => genericRequestTemplate('verify-valid-contract-id', null, 'GET', token, params)
const verifyToken = (body) => genericRequestTemplate('verify-token', body, 'POST', false)
const logIn = (body) => genericRequestTemplate('login', body, 'POST', false)
const deleteFileFromBuckets = (body, token) => genericRequestTemplate('delete-file-from-buckets', body, 'POST', token)
const generateTableauJwt = (token) => genericRequestTemplate('generate-jwt', null, 'GET', token)
const logIntoTableau = (token) => genericRequestTemplate('log-into-tableau', null, 'GET', token)
const generateErrorLog = (body) => genericRequestTemplate('generate-error-log', body, 'POST', false)
const generateFileLog = (body, token) => genericRequestTemplate('generate-file-log', body, 'POST', token)
const getHistoryLogs = (params, token) => genericRequestTemplate('get-history-log', null, 'GET', token, params, '')
const getErrorsLog = (params, token) => genericRequestTemplate('get-errors-log', null, 'GET', token, params, '')
const getSignedUrl = (params, token) => genericRequestTemplate('get-signed-url', null, 'GET', token, params, '')

module.exports = {
  verifyValidContractId,
  deleteFileFromBuckets,
  generateTableauJwt,
  logIntoTableau,
  generateErrorLog,
  generateFileLog,
  getHistoryLogs,
  getErrorsLog,
  getSignedUrl,
  verifyToken,
  logIn,
}


